import React, {Component} from "react";
import UsageHorizontalChart from "./horizontal-chart.component";


class BreakdownUsageTrend extends Component {
    render() {       
        return (
           <div className="usage-spend-wrapper">
                <UsageHorizontalChart printData={this.props.printData} usageSpendBarData={this.props.usageSpendBarData} data={this.props.usageSpendLineData} chartWidth={this.props.chartWidth} setRef={this.props.setRef} resetData={this.props.resetData} dateCurrentMonth={this.props.dateCurrentMonth}/>
           </div>
        )
    }
}

export default BreakdownUsageTrend
